import { isGuardianDomain } from './domain.js';

const ACCOUNT_ID = 1257;
const PRIVACY_MANAGER_USNAT = 1068329;
const PROPERTY_ID = 7417;
const PROPERTY_ID_AUSTRALIA = 13348;
const PRIVACY_MANAGER_TCFV2 = 106842;
const PRIVACY_MANAGER_AUSTRALIA = 1178486;
const ENDPOINT = isGuardianDomain() ? "https://sourcepoint.theguardian.com" : "https://cdn.privacy-mgmt.com";

export { ACCOUNT_ID, ENDPOINT, PRIVACY_MANAGER_AUSTRALIA, PRIVACY_MANAGER_TCFV2, PRIVACY_MANAGER_USNAT, PROPERTY_ID, PROPERTY_ID_AUSTRALIA };
